import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "isError", "htmlFor", "weight"];
import React from 'react';
import style from './style.module.scss';
var defaultProps = {
  isError: false
};

var Label = function Label(_ref) {
  var children = _ref.children,
      isError = _ref.isError,
      htmlFor = _ref.htmlFor,
      weight = _ref.weight,
      attr = _objectWithoutPropertiesLoose(_ref, _excluded);

  var calculatedClassName = "\n    " + style.label + "\n    " + (isError ? style['label--error'] : '') + "\n    " + (weight ? style["label--" + weight] : '') + "\n  ";
  return /*#__PURE__*/React.createElement("label", _extends({
    className: calculatedClassName,
    htmlFor: htmlFor
  }, attr), children);
};

Label.defaultProps = defaultProps;
export default Label;